import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

const RelatedItemPrice = ({ priceUI, currency }) => {
    const price = get(priceUI, `converted_amounts[${currency}]`);
    const priceDisplays = get(priceUI, 'states.price_displays');
    const showPriceUponRequest = !!get(priceDisplays, 'show_price_upon_request');

    return price ? (
        <FormattedMessage
            id="pdp.RelatedItemPrice.price"
            defaultMessage={`{price}`}
            values={{ price }}
        />
    ) : showPriceUponRequest ? (
        <FormattedMessage
            id="pdp.RelatedItemPrice.priceUponRequest"
            defaultMessage="Price Upon Request"
        />
    ) : null;
};

RelatedItemPrice.propTypes = {
    priceUI: PropTypes.object,
    currency: PropTypes.string,
};

export default RelatedItemPrice;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/RelatedItemPrice/RelatedItemPrice.jsx